import FacebookIcon from "@/assets/images/facebook.svg";
import TwitterIcon from "@/assets/images/twitter.svg";
import EmailIcon from "@/assets/images/email.svg";

export default {
  install(Vue) {
    Vue.component("facebook-icon", FacebookIcon);
    Vue.component("twitter-icon", TwitterIcon);
    Vue.component("email-icon", EmailIcon);
  }
};
